module.exports = __webpack_public_path__ + "0c19e9c8b284da95efe04d8a06939b84.MP3";